"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhoDDB3SearchResponse = exports.KoDDSearchResponse = exports.AtcCodeSearchResponse = exports.MeddraSearchResponse = void 0;
class MeddraSearchResponse {
}
exports.MeddraSearchResponse = MeddraSearchResponse;
class AtcCodeSearchResponse {
}
exports.AtcCodeSearchResponse = AtcCodeSearchResponse;
class KoDDSearchResponse {
}
exports.KoDDSearchResponse = KoDDSearchResponse;
class WhoDDB3SearchResponse {
}
exports.WhoDDB3SearchResponse = WhoDDB3SearchResponse;
//# sourceMappingURL=dokdo.js.map